import React from 'react'

const IconBeta = ({ style = {}, ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        fill="#16A5F3"
        d="M11.73 1v7c0 1-6.13 1-6.13 0V1L5.599.999c-3.88 1.69-5.65 6.2-3.96 10.08 .86 1.99 2.54 3.52 4.6 4.2l-2.12 9.71h0c-.15.65-.15 1.34 0 2H4.11c.5 2.51 2.94 4.14 5.45 3.64 2.51-.51 4.14-2.95 3.64-5.46 -.02-.07-.03-.13-.05-.19l-2.12-9.73 0-.001c4.01-1.35 6.17-5.69 4.82-9.7 -.69-2.05-2.2-3.71-4.17-4.58ZM8.67 28v0c-1.18 0-2.13-.96-2.13-2.13 0-1.18.95-2.13 2.13-2.13 1.17 0 2.13.95 2.13 2.13v0c0 1.17-.96 2.13-2.13 2.13ZM27 17V9v0l1.53-2.29 -.001-.001c.29-.45.35-1.01.16-1.5l-1.28-3.21v0c-.26-.61-.85-1.01-1.5-1h-1.81v0c-.66-.01-1.25.39-1.5 1l-1.28 3.21V5.2c-.2.49-.14 1.05.16 1.5l1.52 2.29v8 0c-2.21 0-4 1.79-4 4v6 0c0 2.2 1.79 4 4 4h4v0c2.2 0 4-1.8 4-4v-6 0c0-2.21-1.8-4-4-4Z"
      />
    </svg>
  )
}

export default IconBeta
